<template>

    <HeaderSection></HeaderSection>
  
    <div class="sectionWrapperPurple" :style="{backgroundColor:jsonContent.profilColor1}">



<div class="modal fade-in"  v-show="showModal">
  <div class="modalInner"> 
    <span v-on:click='showModal = !showModal' style="cursor: pointer;" >
      <svg xmlns="http://www.w3.org/2000/svg" height="2em" viewBox="0 0 512 512"><!--! Font Awesome Pro 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM178.3 178.3c-3.1 3.1-3.1 8.2 0 11.3L244.7 256l-66.3 66.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L256 267.3l66.3 66.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L267.3 256l66.3-66.3c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L256 244.7l-66.3-66.3c-3.1-3.1-8.2-3.1-11.3 0z"/></svg>
    </span>
    <br><br>
    <h2>Check device compatibility</h2>
<div style="padding-bottom: 25px;">
  Please refer to the device manufacturer website for variations per country and ensure the device is not SIM locked.
</div>

    <div>
      <input type="text" class="serchDeviceInput" @keyup="serchDevices()" value="" placeholder="Enter phone model or manufacturer" name="checkDevice" id="checkDevice">
    </div>
    <div id="deviceResponse" style="padding-top: 15px; font-weight: bold; color: #6B207D;"></div>
<ul id="deviceList" v-if="showDeviceList">
  <li v-for="item in devices" :key="item.id" >
    <section class="deviceGrid" @click="showDevice(''+item.manufacturer + ' ' +  item.device )">
      <div>{{item.manufacturer}} {{ item.device }}</div>
      <span style="color: green; font-size: 12px;">eSim Compatible</span>
    </section>
  </li>
  <li v-show="showNoDevicesFound" id="nodevicesfound"><div></div><span>No compatible devices found</span></li>
</ul>
  </div>
</div>


<div class="modal2 fade-in"  v-show="modalCoverage">
  <div class="modalInner2"> 
    <span v-on:click='modalCoverage = !modalCoverage' style="cursor: pointer;" >
      <svg xmlns="http://www.w3.org/2000/svg" height="2em" viewBox="0 0 512 512"><!--! Font Awesome Pro 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM178.3 178.3c-3.1 3.1-3.1 8.2 0 11.3L244.7 256l-66.3 66.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L256 267.3l66.3 66.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L267.3 256l66.3-66.3c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L256 244.7l-66.3-66.3c-3.1-3.1-8.2-3.1-11.3 0z"/></svg>
    </span>
    <br><br>
    <h2>Data coverage</h2>
<div>

<p>
<img src="/images/worldmap_ship_sat.png" alt="World map" style="margin: 20px auto; display: block; max-width: 100%;;">
</p>

<div  class="dataCoverageList">
  <p>
AFGHANISTAN<br>ALBANIA<br>ANGUILLA<br>ANTIGUA AND BARBUDA<br>ARGENTINA<br>ARMENIA<br>AUSTRALIA<br>AUSTRIA<br>BAHAMAS<br>BAHRAIN<br>BANGLADESH<br>BARBADOS<br>BELGIUM<br>BENIN<br>BERMUDA<br>BOLIVIA<br>BOTSWANA<br>BR VIRGIN ISLANDS<br>BRAZIL<br>BRUNEI DARUSSALAM<br>BULGARIA<br>CAMBODIA<br>CANADA<br>CAPE VERDE<br>CAYMAN ISLAND<br>CHILE<br>CHINA<br>COLOMBIA<br>CONGO THE DEMOCRATIC REPUBLIC<br>COSTA RICA<br>CROATIA<br>CYPRUS<br>CZECH REPUBLIC<br>DENMARK<br>DOMINICA<br>DOMINICAN REPUBLIC<br>ECUADOR<br>EGYPT<br>EL SALVADOR<br>ESTONIA<br>FAROE ISLANDS<br>FIJI<br>FINLAND<br>FINLAND ALAND<br>FRANCE<br>FRENCH GUIANA<br>GEORGIA<br>GERMANY<br>GHANA<br>GIBRALTAR<br>GREECE<br>GRENADA<br>GUADELOUPE<br>GUATEMALA<br>GUERNSEY<br>GUINEA<br>GUINEA-BISSAU<br>GUYANA<br>HAITI<br>HONDURAS<br>HONG KONG<br>HUNGARY<br>ICELAND<br>INDIA<br>INDONESIA<br>IRAQ<br>IRELAND<br>ISLE OF MAN<br>ISRAEL<br>ITALY<br>JAMAICA<br>JAPAN<br>JERSEY<br>JORDAN<br>KAZAKHSTAN<br>KENYA<br>KOREA REPUBLIC OF<br>KOSOVO<br>KUWAIT<br>KYRGYZSTAN<br>LATVIA<br>LESOTHO<br>LIECHTENSTEIN<br>LITHUANIA<br>LUXEMBOURG<br>MACEDONIA, REPUBLIC OF<br>MALAYSIA<br>MALTA<br>MARTINIQUE<br>MEXICO<br>MOLDOVA<br>MONACO<br>MONGOLIA<br>MONTENEGRO<br>MONTSERRAT<br>MOROCCO<br>MOZAMBIQUE<br>MYANMAR<br>NETHERLANDS<br>NETHERLANDS ANTILLES<br>NEW ZEALAND<br>NICARAGUA<br>NIGERIA<br>NORWAY<br>OMAN<br>PAKISTAN<br>PALESTINIAN TERRITOR<br>PANAMA<br>PAPUA NEW GUINEA<br>PARAGUAY<br>PERU<br>PHILIPPINES<br>POLAND<br>PORTUGAL<br>PUERTO RICO<br>QATAR<br>REPUBLIC OF SOUTH SUDAN<br>REUNION<br>ROMANIA<br>RUSSIAN FEDERATION<br>RWANDA <br>SAINT KITTS AND NEVIS<br>SAINT LUCIA<br>SAINT VINCENT AND THE GRENADINES<br>SAMOA<br>SAUDI ARABIA<br>SENEGAL<br>SERBIA<br>SIERRA LEON<br>SINGAPORE<br>SLOVAKIA<br>SLOVENIA<br>SOUTH AFRICA<br>SPAIN<br>SRI LANKA<br>SURINAME<br>SWAZILAND<br>SWEDEN<br>SWITZERLAND<br>TAIWAN<br>TANZANIA UNITED REPUBLIC OF<br>THAILAND<br>TONGA<br>TRINIDAD AND TOBAGO<br>TURKEY<br>TURKS AND CAICOS ISLANDS<br>UKRAINE<br>UNITED ARAB EMIRATES<br>UNITED KINGDOM<br>UNITED STATES<br>URUGUAY<br>VANUATU<br>VENEZUELA<br>VIETNAM<br>ZAMBIA<br>
</p>
</div>

 

</div>



  </div>
</div>





      <div style="   margin-top: -25px;position: relative;">
        <img :src="jsonContent.heroImage" style="width: 100%;">

        <div class="headerContent">

          <div class="largeAndMediumScreenHeader">
              <h1 class="mainHeading">
                {{ jsonContent.heading1 }}
            
            </h1>
            <h2 class="heading2">{{ jsonContent.heading2 }}</h2>
          </div>


          <div class="largeScreenHeader">

            <div style="font-size: 1.6rem; margin-top: 45px;">Is your phone eSIM compatible?
            <button :style="{backgroundColor:jsonContent.profilColor1}" v-on:click='showModal = !showModal;  showDeviceList = false; document.getElementById("checkDevice").focus();' class="compatibilityBtn">Check compatibility here</button>

        </div>
          </div>


       
        </div>

      </div>

      <div class="smalScreenHeader" style="background-color: #fff;">
        <div style="font-size: 1.6rem; padding: 45px; color: #000;">Is your phone eSIM compatible?
          <button :style="{backgroundColor:jsonContent.profilColor1}" v-on:click='showModal = !showModal;  showDeviceList = false; document.getElementById("checkDevice").focus();' class="compatibilityBtn">Check compatibility here</button>
        </div>
      </div>

      <br><br>


  



      <!-- <div v-if="loginStatus == 'true'"> -->
        <div>

<div style="width: 800px; max-width: 90%; margin:0 auto 30px auto; text-align: justify;">

  <p v-html="jsonContent.introText" />


</div>

          <!-- <a href="#" style="margin-bottom: 10px; font-weight: bold; color: #fff; display: block;" v-on:click='showModal2 = !showModal2;'>
            Check the data coverage here. (link to come)
          </a> -->

        

          <!-- <div style="margin-bottom: 25px; font-weight: bold;">
            No payment required now.  ESIM Non-compatible devices will not be charged.   
          </div> -->



        <h1>Add data bundle to cart:</h1>


    <div class="bundleList">
          <div v-for="(post,index) in  posts.slice().reverse()" :key="post.id" style="display: inline-block; max-width: 100%;" >
            <div class="bundlePack2"  :class="{ 'firstBundle': index === 0 }">

              
           
              <h4>{{ post.name }} <br>{{ post.value + post.label }}</h4>
              <div style="font-size: 0.9rem;">Price: {{ post.price }} {{ post.currency }}</div>
              <div style="margin-bottom:20px; margin-top:6px;font-size: 0.9rem;">Valid for: {{ post.validityperiod }} days</div>
            
      
              <router-link class="checkoutBtn" :class="{'active' : post.id == activeIndex}" :id="post.id" :to="'/'+jsonContent.urlName+'/checkout/'+post.id" >
                Go to checkout 1
              </router-link>
      
    <div style=" border-top: 1px dashed #ccc; border-radius: 0 0 8px 8px; color: #fff; font-weight: bold; padding:15px 5px; margin: -8px; ">

      <div style="max-width: 100%;width: 260px;margin:auto; display: grid; grid-template-columns: 1fr 2fr;">
        <div style="padding-right:10px; color:#000; font-weight: normal;">
        Qty. <input type="number" value="1" :name="'q_'+post.id" :id="'q_'+post.id" class="quantityInput">
      </div>



    <button v-on:click="addBundleToCart(post); showConfirmation(post.id)" class="addToCartBtn" :id="'button_'+post.id">Add to cart</button>



      </div>


    </div>
 
  </div>
<div v-if="index == 0">
  <div style="margin: 20px auto 20px auto; max-width: 460px; font-weight: normal;">{{ jsonContent.bundlePackageInfo }}</div>  
</div>

          </div>



    </div>







<div v-if="cart_Status > 0" style="margin:20px 0 35px 0;">
  <div ><strong>{{ cart_Status }}</strong> eSim Packages in your cart</div>
<router-link class="goToCheckOutBtn"  :to="'/'+jsonContent.urlName+'/checkout/'" >
            Go to checkout 2
          </router-link>

</div>


<FaqSection :company="jsonContent.urlName"></FaqSection>

   
    </div>
    </div>


    
     
  
      <FooterSection></FooterSection>
  
  
  
  </template>
  
  
  <style>

.compatibilityBtn {
  background-color: #6B207D; cursor: pointer; color:#fff; font-size: 1.5rem; padding:25px 35px; border:none; border-radius: 12px;
            display:block;margin-top: 25px; max-width: 92%;
}
.compatibilityBtn:hover {
  box-shadow: 0 0 5px #000;
}

/******modal 1****************** */

.modal{
  background-color: rgba(0,0,0,0.5);
  padding: 0;
  margin:0;
  position: fixed;
  top:0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  z-index: 11;
}

.modalInner{
  background-color: #fff;
  padding: 3%;
  color: #000;
  margin:0;
  position: absolute;
  top:125px;
  left: 17%;
  width: 60%;
  min-height: 200px;
  z-index: 12;
  box-shadow: 0 0 15px #333;
  border-radius: 6px;

}

.modal .serchDeviceInput {
  padding: 12px 25px;
    border:1px solid #000;
    border-radius: 6px;
    width: 400px;
    max-width: 80%;
    font-size: 1.2rem;
}
/************************ */


/******modal 2****************** */

.modal2{
  background-color: rgba(0,0,0,0.5);
  padding: 0;
  margin:0;
  position: fixed;
  top:0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  z-index: 11;
}

.modalInner2{
  background-color: #fff;
  padding: 3%;
  color: #000;
  margin:0;
  position: absolute;
  top:5%;
  left: 17%;
  width: 60%;
  min-height: 200px;
  z-index: 12;
  box-shadow: 0 0 15px #333;
  border-radius: 6px;
  overflow-y: scroll;
  max-height: 70vh;
}

.dataCoverageList {
  padding-bottom: 25px; 
  columns: 3; 
  text-align: left;
 }

/************************ */



ul#deviceList  {
  list-style: none;
  text-align: left;
  width: 400px;
  max-width: 100%;
  display: block;
  margin:15px auto;
  padding: 0;
  max-height: 400px;
  overflow-y: scroll;
  border:1px solid rgb(246, 140, 77);
}
ul#deviceList li {
  margin:3px 0;
  padding:8px;
}

ul#deviceList li:hover {
  background-color: rgb(246, 140, 77);
  color: #fff;
  cursor: pointer;
}

.deviceGrid {
  display: grid;
  grid-template-columns: 2fr 1fr;
}

/*********************** */

.headerContent {
  position: absolute; top: 5%;left:50px; bottom:0; width:90%; text-align: left;text-shadow: 1px 1px 10px black; 
}

.pageWrapper {
  background-color: #6B207D;
}

h1{color: #fff;}

h1.mainHeading {
 font-size: 3rem; margin-bottom: 0px;   
}
h2.heading2 {
  font-size: 1.65rem; margin-top: 0px;  
}

.bundleList {
  max-width: 600px;
  margin: auto;
  margin-bottom:40px;
}



  .bundlePack2 {
    display: inline-block;
    padding:8px;
    margin:8px;
    /* border:1px solid #ccc; */
    background-color: #fff;
    border-radius:8px;
    width: 260px;
    max-width:100%;
    color: #333;
    text-decoration: none;
  }
  
  .bundlePack2:hover {
    background-color: #eee;
    /* cursor: pointer; */
  
  }

  .firstBundle{
    width: 550px;
    max-width:92%;
}


.firstBundle h4{
    font-size: 1.4rem;
}
  
  .checkoutBtn {
    display: none;
    padding:5px 20px;
    border-radius: 8px;
    text-decoration:none;
    background-color: #555;
    color:#fff;

  }
  
  .checkoutBtn:hover {
    background-color: #000;
  
  }

  .quantityInput {
    width: 30px;
    border: 1px solid #f68c4d;
    height: 22px;
    margin-bottom: 0px;
    color: #fff;
    text-align: center;
    padding: 4px;
    background-color: transparent;
    color: #000;
    border-radius: 6px;
  }

.addToCartBtn {
  cursor: pointer;
    border: 1px solid #fff;
    padding: 6px;
    margin: 0 auto 0 auto;
    width: 150px;
    font-weight: normal;
    background-color: rgb(246, 140, 77); 
    border-radius: 6px;
    color: #fff;
}

.addToCartBtn:hover {

    border: 2px solid #fff;
    padding: 5px;
  

}


.goToCheckOutBtn {
  margin-top: 15px;
  padding:15px 25px;
    border-radius: 8px;
    font-weight: bold;
    text-decoration:none;
    background-color: #fff;
    color:#000;
    display: inline-block;
}  
.goToCheckOutBtn:hover {
background-color: #f68c4d;
color: #fff;
}


  .active {display: block;}


.largeScreenHeader{

}

  .smalScreenHeader {
      display: none;
   
    }

  
  @media only screen and (max-width: 960px) {
  
    .largeScreenHeader {
      display: none;
    }

      
    .smalScreenHeader {
      display: block;
    }

    
h1.mainHeading {
 font-size: 2.35rem; margin-bottom: 0px;   
}
h2.heading2 {
  font-size: 1.25rem; margin-top: 0px;  
}

    .compatibilityBtn {
   font-size: 1.2rem; padding:15px 25px; 
            display:block;margin-top: 25px; margin:25px auto; 
    }

    .dataCoverageList {
  columns: 2; 

 }

}

  @media only screen and (max-width: 600px) {


    .headerContent {
  position: relative; top: 0;left:0; bottom:0;
  padding: 5px 5px 25px 5px;
  text-align: center; 
}

    .firstBundle{
      width: 260px;
      max-width:100%;
  }

  h1.mainHeading {
 font-size: 2rem; margin-bottom: 0px;   
}
h2.heading2 {
  font-size: 1.1rem; margin-top: 0px;  
}



.modalInner{
  padding: 3%;
  margin:0;
  top:125px;
  left: 7%;
  width: 80%;
  min-height: 200px;
  z-index: 12;
}


.modalInner2{
  padding: 3%;
  margin:0;
  left: 7%;
  width: 80%;
  min-height: 200px;
}

.dataCoverageList {
  columns: 1; 

 }

}

  </style>
  
  
  
  
  <script setup>
  
  import { ref, onBeforeMount  } from 'vue'
  import HeaderSection from '../components/HeaderSection.vue'
  import FaqSection from '../components/FaqSection.vue'
  import FooterSection from '../components/FooterSection.vue'
  // import { CheckStatus2,loginStatus,CartStatus,cart_Status } from '@/modules/modules.js'
  import { CheckStatus2,CartStatus,cart_Status,modalCoverage,showModal } from '@/modules/modules.js'
  import { useRouter } from 'vue-router'
  import { jsonContent,getContent } from '@/modules/content.js'

  // import ambassadorContent from '../assets/files/ambassador.json'
  // import carnivalContent from '../assets/files/carnival.json'



  const router = useRouter()

  // const customers = {
  //     default: ambassadorContent,
  //     ambassador: ambassadorContent,
  //     carnival: carnivalContent
  //   };

  //   const ContentDefault = 'default'
  //   const Content = computed(() => customers[router.currentRoute.value.params.id || ContentDefault] )
  //   let jsonContent = Content;


  
  const posts = ref([])
  const activeIndex = ref(null)
  let cartItems = ref([])
  // let showModal = ref();
  const devices = ref([]);
  const showDeviceList = ref(false);
  const showNoDevicesFound= ref(false);

  let cartListJson = ref(JSON.parse(localStorage.getItem('bundleCart_'+router.currentRoute.value.params.id))??[])
  //let authStatus = ref("-")
 
  
  console.log("here:" + process.env.VUE_APP_API_EDNPOINT);
  



  /*************************** */

var configDevices = {
  method: 'get',
maxBodyLength: Infinity,
  url: process.env.VUE_APP_API_EDNPOINT+'/api/devicelist'
};

  /************************** */


  onBeforeMount(async () => {

    getContent(router.currentRoute.value.params.id);

    document.title =   "eSim Portal - " + router.currentRoute.value.params.id.toUpperCase() ;


    /************************ */
    var axios = require('axios');
  
  var config = {
    method: 'get',
  maxBodyLength: Infinity,
    url: process.env.VUE_APP_API_EDNPOINT+'/api/ProductBundles/' + jsonContent.value.urlName 
  };
  

    axios(config)
  .then(function (response) {
    posts.value = response.data;
    CheckStatus2()
    console.log(JSON.stringify(posts.value));
   
    showModal.value = false;

    axios(configDevices)
.then(function (response) {
  devices.value = response.data;
  //console.log("h2: " + devices.value);
});

  })
  .catch(function (error) {
    console.log(error);
  });
  
  
  })
  
  

  // function checkCart(id)
  // {
  //   let cart = []
  //       if( localStorage.getItem('bundleCart_'+router.currentRoute.value.params.id))
  //       {
  //           cart = JSON.parse(localStorage.getItem('bundleCart_'+router.currentRoute.value.params.id));
  //       } 


  //   var pos = cart.map(val => val.bundleId).indexOf(id);

  //   console.log(pos);
  //   if(pos > -1)
  //   {
  //     cart[pos].quantity = Number(cart[pos].quantity) + Number(1);
  //   localStorage.setItem('bundleCart_'+router.currentRoute.value.params.id, JSON.stringify(cart))

  //   console.log(pos);
  //   }
  //   else
  //   {
  //     console.log("not in cart ");
  //   }

  //   CartStatus();

  // }

  
  function addBundleToCart(data)
  {
    var price = data.price;

    let bundle = {
            //digiDownloadeEmail:digiDownloadeEmail.value,
            bundleId:data.id,
            bundleName:data.name + " " + data.value + " " + data.label,
            bundlePriceCurrency:data.currency,
            bundlePrice:price,
            bundSize:data.value + " " + data.label,
            bundPeriode:data.validityperiod,
            quantity: document.getElementById("q_"+data.id).value
        }

        let cart = []
        if( localStorage.getItem('bundleCart_'+router.currentRoute.value.params.id))
        {
            cart = JSON.parse(localStorage.getItem('bundleCart_'+router.currentRoute.value.params.id));
        } 
        else
        {
            localStorage.setItem('bundleCart_'+router.currentRoute.value.params.id,'[]')
        }


        /************************ */
        var pos = cart.map(val => val.bundleId).indexOf(data.id);

        if(pos > -1)
        {
          //update quantity in cart
          cart[pos].quantity = Number(cart[pos].quantity) + Number(document.getElementById("q_"+data.id).value);
          //localStorage.setItem('bundleCart_'+router.currentRoute.value.params.id, JSON.stringify(cart))
          
          cartItems.value =   JSON.stringify(cart)
          cartListJson.value = JSON.parse(cartItems.value);
        }
        else
        {
          //not in cart, add new
          
          const getCart = cartItems.value;
          if(getCart.length > 2){
          
          cart = JSON.parse(cartItems.value??[])
          cart.push(bundle)
          cartItems.value =   JSON.stringify(cart)
          }else{
              cart.push(bundle)
              cartItems.value =   JSON.stringify(cart)
          }

          cartListJson.value = JSON.parse(cartItems.value)

        }

        /************************* */



        
     
        localStorage.setItem('bundleCart_'+router.currentRoute.value.params.id, JSON.stringify(cartListJson.value))
        CartStatus(router.currentRoute.value.params.id)
  }
  
  
//   function saveToLocalStorage(data) {
//         localStorage.setItem('bundle',JSON.stringify(data))
      
//         activeIndex.value = data.id;
//         //localStorage.setItem('activeIndex', activeIndex.value);
//         var price = 19;
//         if(data.value == "20480"){
//           price = 39;
//         }
//         else if(data.value == "10240")
//         {
//           price = 29;
//         }
//         else if(data.value == "5120")
//         {
//           price = 19;
//         }
  
//         localStorage.setItem('price',price)
//         localStorage.setItem('prodId',data.id)
  
//       }
  
  



function serchDevices() {

  var teller = 0;

if(document.getElementById("checkDevice").value.length > 1)
{
  showDeviceList.value = true;
  document.getElementById("deviceResponse").innerHTML = '';
 


    var input, filter, ul, li, a, i, txtValue;
    input = document.getElementById("checkDevice");
    filter = input.value.toUpperCase();
    ul = document.getElementById("deviceList");
    li = ul.getElementsByTagName("li");
    for (i = 0; i < li.length; i++) {
        a = li[i].getElementsByTagName("div")[0];
        txtValue = a.textContent || a.innerText;
        if (txtValue.toUpperCase().indexOf(filter) > -1) {
            li[i].style.display = "";
            teller++;
        } else {
            li[i].style.display = "none";
            
        }
    }

  

}
else
{
  showDeviceList.value = false;
  document.getElementById("deviceResponse").innerHTML = '';
  teller = 0;

}
  console.log("teller: " + teller);
  if(teller < 1)
  {
    showNoDevicesFound.value = true;
    document.getElementById("nodevicesfound").style.display = "block";
  }
  else
  {
    showNoDevicesFound.value = false;

  }


}


function showDevice(device)
{
  showDeviceList.value = false;
  document.getElementById("deviceResponse").innerHTML = device + " is eSim compatible";

}


function showConfirmation(target)
{
  
      document.getElementById('button_'+target).style.backgroundColor = '#6B207D'; 
      document.getElementById('button_'+target).innerText = cart_Status.value +' items in cart'; 
      

      setTimeout(() => {
        document.getElementById('button_'+target).style.backgroundColor = '#f68c4d'; 
        document.getElementById('button_'+target).innerText = 'Add to cart'; 
      }, 1500);




}

  </script>
  
  
  
  